import styled from 'styled-components';

export const Height = styled.div<{ units: number; mobile?: boolean }>`
  height: ${(props) => (props.mobile ? '100%' : `${4 * props.units}px`)};
  display: flex;
  flex-direction: column;
`;
